import { KompisSheetHeader } from '@inter-ikea-kompis/react-components';
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import Title from 'ui/Typography/Title';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import { useSelector } from 'react-redux';
import { isAvailabilitySheetVisible, setAvailabilitySheetVisible } from 'ducks/sheets';
import Button, { ButtonTypeEnum } from 'ui/Button/Button';
import SheetBox from 'ui/Sheet/SheetBox';
import { useHistory } from 'react-router-dom';
import { e2e } from 'utils/queryUtils';
import { isMobile } from 'utils/platform';
import Sheet from 'ui/Sheet/Sheet';
import HomeDelivery, {
  ReportCurrentPageEnum
} from 'components/ProductSidebar/HomeDelivery/HomeDelivery';
import StoreSelector from 'components/ProductSidebar/StoreSelector/StoreSelector';
import { reportSetNoAvailability } from 'analytics/reporters';
import { useAvailability } from 'contexts/availability';
import { useAppDispatch } from 'ducks/hooks';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import styled from 'styled-components';
import Divider from 'ui/Divider/Divider';
import { useServiceSettings } from 'contexts/serviceSettings';

export const LOCALSTORAGE_AVAILABILITY = 'AvailabilityConfirmed';

export enum ReportSetNoAvailabilityEnum {
  noThanksButton = 'no_thanks_button',
  xButton = 'x_button'
}

const ConfirmationButtonWrapper = styled.div`
  flex-grow: 1;
  align-content: end;
`;

const AvailabilitySheet = () => {
  const { formatMessage } = useIntl();
  const dispatch = useAppDispatch();
  const { storeId, stores, zipCode } = useAvailability();
  const visible = useSelector(isAvailabilitySheetVisible);
  const history = useHistory();

  const { dexfSettings } = useServiceSettings();

  useEffect(() => {
    if (
      dexfSettings.kompis.serviceSettings.storeAvailabilityDataSource !== 'disabled' &&
      dexfSettings.kompis.serviceSettings.zipAvailabilityDataSource !== 'disabled' &&
      !storeId &&
      !zipCode &&
      !localStorage.getItem(LOCALSTORAGE_AVAILABILITY) &&
      history.location.pathname === '/planner' &&
      !e2e()
    ) {
      dispatch(setAvailabilitySheetVisible(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history.location.pathname]);

  const onClose = (exitButton: ReportSetNoAvailabilityEnum) => {
    dispatch(setAvailabilitySheetVisible(false));
    reportSetNoAvailability({ exitButton });
  };

  const onConfirm = () => {
    localStorage.setItem(LOCALSTORAGE_AVAILABILITY, 'true');
    dispatch(setAvailabilitySheetVisible(false));
  };

  return (
    <Sheet
      onOverlayClick={() => onClose(ReportSetNoAvailabilityEnum.xButton)}
      data-testid="availability-sheet"
      visible={visible}
    >
      {visible && (
        <>
          <KompisSheetHeader
            theme={SkapaTheme}
            backIcon={false}
            onCloseButtonClick={() => onClose(ReportSetNoAvailabilityEnum.xButton)}
            heading=""
            zIndex={1}
          />
          <SheetBox style={{ height: '100%' }}>
            <Title type={ThemeFontStyleTypeEnum.headingMedium}>
              {formatMessage({ id: 'storageone.availabilitySheetTitle' })}
            </Title>
            <HomeDelivery
              mt={isMobile() ? 'xxl' : 'xxxl'}
              currentPage={ReportCurrentPageEnum.availabiltySheet}
            />
            <StoreSelector
              mt={'md'}
              mb={isMobile() ? 'xxl' : 'xxxl'}
              storeId={storeId}
              stores={stores}
              currentPage={ReportCurrentPageEnum.availabiltySheet}
            />
            <ConfirmationButtonWrapper>
              <Divider style={{ margin: '0px -3rem 2rem -3rem' }} />
              {storeId || zipCode ? (
                <Button
                  type={ButtonTypeEnum.primary}
                  text={formatMessage({ id: 'storageone.availabilitySheetConfirmButton' })}
                  onClick={onConfirm}
                  width={'100%'}
                />
              ) : (
                <Button
                  type={ButtonTypeEnum.secondary}
                  text={formatMessage({ id: 'storageone.availabilitySheetNoThanksButton' })}
                  onClick={() => {
                    reportSetNoAvailability({
                      exitButton: ReportSetNoAvailabilityEnum.noThanksButton
                    });
                    onConfirm();
                  }}
                  width={'100%'}
                />
              )}
            </ConfirmationButtonWrapper>
          </SheetBox>
        </>
      )}
    </Sheet>
  );
};

export default AvailabilitySheet;
